import { Link, useSearchParams } from 'react-router-dom';
import { CATEGORIES } from '@/mocks/site';

interface CategoryTabsProps {
  active: string;
}

export default function CategoryTabs({ active }: CategoryTabsProps) {
  const [searchParams] = useSearchParams();
  const search = searchParams.get('search');

  return (
    <div className="flex items-center gap-1 overflow-x-auto pb-2 scrollbar-hide">
      {CATEGORIES.map((cat) => {
        const isActive = cat.key === active;
        const to = search ? `/category/${cat.key}?search=${encodeURIComponent(search)}` : `/category/${cat.key}`;
        return (
          <Link
            key={cat.key}
            to={to}
            className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
              isActive
                ? 'bg-primary-500 text-background-50 shadow-sm'
                : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-800'
            }`}
          >
            {cat.label}
          </Link>
        );
      })}
    </div>
  );
}